module.exports = __webpack_public_path__ + "img/service-donor.9cca5e47.jpg";